import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { updateLocator } from '../../services/locatorManagementService';

export const updateLocatorAsync = createAsyncThunk(
  'locatorManagement/update',
  async ({ id, locator_type, locator_value }, { rejectWithValue }) => {
    try {
      return await updateLocator(id, { locator_type, locator_value });
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Update failed.');
    }
  },
);

const updateLocatorSlice = createSlice({
  name: 'updateLocator',
  initialState: { loading: false, error: null, successMsg: null },
  reducers: {
    clearMessages(state) {
      state.error = null;
      state.successMsg = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateLocatorAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMsg = null;
      })
      .addCase(updateLocatorAsync.fulfilled, (state) => {
        state.loading = false;
        state.successMsg = 'Locator updated.';
      })
      .addCase(updateLocatorAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = updateLocatorSlice.actions;
export const selectUpdateLoading = (state) => state.updateLocator.loading;
export const selectUpdateError = (state) => state.updateLocator.error;
export const selectUpdateSuccessMsg = (state) => state.updateLocator.successMsg;
export default updateLocatorSlice.reducer;
